import { ReactElement } from 'react'
import { Modal, Input, FlexWrapper } from '../../../components'
import strings from '../../../locale/en'

interface CreateTestModalProps {
  handleCancel: () => void
  handleSubmit: () => void
}

const CreateSectionModal = ({
  handleCancel,
  handleSubmit
}: CreateTestModalProps): ReactElement => {
  const {
    button: { createSectionText, save, cancel },
    menu: {
      admin: {
        createTest: {
          enterSectionName,
          startQuestionPosition,
          endQuestionPosition
        }
      }
    }
  } = strings
  return (
    <Modal
      handleCancel={handleCancel}
      handleSubmit={handleSubmit}
      title={createSectionText}
      description={''}
      submitButtonText={save}
      cancelButtonText={cancel}
    >
      <FlexWrapper justifyContent="center">
        <Input
          placeholder={enterSectionName}
          value=""
          name={enterSectionName}
          onBlur={() => {}}
          error={''}
          onChange={() => {}}
          hasPadding={false}
          width="75%"
          height="50px"
        />
        <Input
          placeholder={startQuestionPosition}
          value=""
          name={startQuestionPosition}
          onBlur={() => {}}
          error={''}
          onChange={() => {}}
          hasPadding={false}
          width="75%"
          height="50px"
          inputType="number"
        />
        <Input
          placeholder={endQuestionPosition}
          value=""
          name={endQuestionPosition}
          onBlur={() => {}}
          error={''}
          onChange={() => {}}
          hasPadding={false}
          width="75%"
          height="50px"
          inputType="number"
        />
      </FlexWrapper>
    </Modal>
  )
}

export default CreateSectionModal
